module.exports = __webpack_public_path__ + "static/media/ptc.logo.160w.e7555252.png";